import type { AxiosRequestConfig } from 'axios';
import axios from 'axios';

export type sendFeedbackToClientsOptions = {
  listingId: string;
  appointmentIds: string[];
  contactIds: string[];
};

const sendFeedbackToClients = async ({
  listingId,
  appointmentIds,
  contactIds,
}: sendFeedbackToClientsOptions) => {
  const config: AxiosRequestConfig = {
    url: `/listing/${listingId}/send_feedback_to_clients`,
    method: 'post',
    data: { contactIds, appointmentIds },
  };

  await axios.request(config);
};

export default sendFeedbackToClients;
